export default __webpack_public_path__ + "static/steamTunnel-e81e32235f500f13b3fd12d5d73e4b3a.svg";